import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

/** Layout wrapper for table toolbar + scroll area. Does not scroll. */
export default function DataTableShell({ children, className = '' }: Props) {
  const classes = ['data-table-shell', 'data-table-root', className].filter(Boolean).join(' ');
  return <div className={classes}>{children}</div>;
}
